<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onAdd(close)">
			<div class="modal-header py-2">
				<h1 class="modal-title fs-5">{{$t('header.students-add')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="text-center" v-if="loading">
					<loading-spinner
						:overlay="loading"
						:text="$t('text.loading-data')"
					></loading-spinner>
				</div>
				<div v-else>
					<div>
						<label for="input-fios" class="form-label">{{$t('text.students-fios-via-enter')}}:</label>
						<textarea id="input-fios" ref="fios" rows="3" :placeholder="$t('placeholder.students-fios-via-enter')" class="form-control" v-model="fios" required></textarea>
					</div>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-primary" :disabled="loading">{{$t('btn.add')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import autosize from 'autosize';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		fios: '',
		
		error: '',
		loading: false,
	}),
	methods: {
		async onAdd(close){
			this.loading = true;
			this.error = '';
			
			const fios = this.fios.trim().split('\n');
			if(fios.length > 0){
				for(const fio of fios){
					if(fio.trim()){
						await this.appModel.doAddStudent(this.$vfm.modals[0].params._value.group_id, {
							fio: fio.trim(),
						});
					}
				}
				this.$emit('add', close);
			} else {
				this.$emit('cancel', close);
			}
			this.loading = false;
		},
	},
	async mounted(){
		setTimeout(() => {
			autosize(this.$refs.fios);
			this.$refs.fios.focus();
		}, 300);
	},
	components: {
		LoadingSpinner,
	},
}
</script>